module.exports = {
  "debug": {
    "hello": "Hello",
    "count": "Number is {{count}}",
    "change_lang": "Change to {{lang}}",
    "changed": "Changed",
  },
  "common": {
    "operator": "Operator"
  },
};